import { Line } from "@ant-design/charts";
import { Modal, Button } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useRef, useState, useEffect } from "react";
import { CSVLink } from "react-csv";

import { useGraphTheme } from "../../../hooks/useGraphTheme";
import { showErrorNotification, showSuccessNotification } from "../../../utils/notification";

const CourseReminderGraphModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  courseReminderStats = [],
  courseReminderCount = 0,
  courseId,
  ROOT_URL
}) => {
  const graphTheme = useGraphTheme();
  const [courseRemindButtonCsvData, setCourseRemindButtonCsvData] = useState([]);
  const [downloadedFileName, setDownloadedFileName] = useState("RemindUsData.csv");
  const UserStatsConfig = {
    data: courseReminderStats || [],
    height: 400,
    xField: "date",
    yField: "count",
    point: {
      size: 5,
      shape: "diamond"
    }
  };
  const csvLinkRef = useRef(null);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDownloadCsv = () => {
    axios
      .get(`${ROOT_URL}/admin/courses/reminder-stats-data`, {
        params: {
          courseId
        }
      })
      .then((res) => {
        const remindUsDataList = res?.data || [];
        setDownloadedFileName(
          `${remindUsDataList[0]?.batch}-${remindUsDataList[0]?.level}-RemindUsData.csv`
        );
        setCourseRemindButtonCsvData(
          remindUsDataList?.map((remindUsData) => {
            return {
              "User Name": remindUsData?.name,
              "User Email": remindUsData?.email,
              Batch: remindUsData?.batch,
              Level: remindUsData?.level,
              date: dayjs(remindUsData?.date)?.format("YYYY-MM-DD HH:mm:ss")
            };
          })
        );

        showSuccessNotification("CSV downloaded successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  useEffect(() => {
    if (courseRemindButtonCsvData.length > 0 && csvLinkRef.current) {
      csvLinkRef.current.link.click();
    }
  }, [courseRemindButtonCsvData]);

  return (
    <Modal
      title="Course Reminder Stats"
      open={isModalOpen}
      footer={[]}
      width={2000}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <br />
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <h2>Total: {courseReminderCount}</h2>
        <CSVLink
          asyncOnClick={true}
          data={courseRemindButtonCsvData || []}
          ref={csvLinkRef}
          filename={downloadedFileName}
        />
        <Button
          type="primary"
          onClick={() => {
            handleDownloadCsv();
          }}
        >
          Download CSV
        </Button>
      </div>
      <Line {...UserStatsConfig} {...graphTheme} />
    </Modal>
  );
};
export default CourseReminderGraphModal;
